import { logger } from 'common/services';

import { mapDevicesForOurApp } from './mapDevicesForOurApp';

export const disposeMediaStream = (stream: MediaStream) => {
  const tracks: MediaStreamTrack[] = stream.getTracks();
  for (const track of tracks) {
    try {
      track.stop();
      stream.removeTrack(track);
    } catch (e) {
      logger.error(e);
    }
  }
};

export const getMediaDevices = async () => mapDevicesForOurApp(await navigator.mediaDevices.enumerateDevices());
